export const OUR_PLATFORM_URL = '/our-platform'
